import { gsap, ScrollTrigger } from "@/lib/gsap";

gsap.registerPlugin(ScrollTrigger);

interface Props {
  triggerRef: HTMLDivElement;

  videoRef: HTMLVideoElement;

  overlayRef: HTMLDivElement;

  blurRef: HTMLDivElement;

  reasonBgRef: HTMLDivElement;
}

export const initHeroBackgroundAnimation = ({
  triggerRef,
  videoRef,
  overlayRef,
  blurRef,
  reasonBgRef,
}: Props) => {
  const tl = gsap.timeline({
    defaults: {
      ease: "none",
    },

    scrollTrigger: {
      trigger: triggerRef,

      start: "top top",
      end: "+=1400",

      scrub: 0.5,

      invalidateOnRefresh: true,

      onEnter: () => {
        videoRef.pause();
      },

      onLeaveBack: () => {
        videoRef.play();
      },
    },
  });

  tl.to(
    videoRef,
    {
      scale: 1.05,
      ease: "none",
      duration: 1,
      force3D: true,
    },
    0
  );

  tl.to(
    overlayRef,
    {
      background: "rgba(0,0,0,0.55)",
      ease: "none",
      duration: 1,
    },
    0
  );


  tl.to(
    blurRef,
    {
      backdropFilter: "blur(8px)",
      background: "rgba(0,0,0,0.10)",
      ease: "none",
      duration: 1,
    },
    0
  );

  tl.to(
    reasonBgRef,
    {
      opacity: 1,
      ease: "none",
      duration: 1,
    },
    0.55
  );

  tl.to(
    blurRef,
    {
      backdropFilter: "blur(0px)",
      background: "rgba(0,0,0,0)",
      ease: "none",
      duration: 1,
    },
    0.75
  );

  tl.to(
    overlayRef,
    {
      background: "rgba(0,0,0,0.08)",
    },
    0.8
  );

  return () => {
    tl.scrollTrigger?.kill();
    tl.kill();
  };
};